import React, { useEffect, useRef, useState } from 'react'
import { getImages } from '../const';
import { Link } from 'react-router-dom';

const HomeVideo = () => {
    const [openMobAccordion, setOpenMobAccordion] = useState(1);
    useEffect(() => {
        const interval = setInterval(() => {
            setOpenMobAccordion(prev => (prev % 3) + 1); // Cycle through 1, 2, 3
        }, 5000);

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, []);

    const handleMobAccordion = (item) => {
        setOpenMobAccordion(item)
    }
    const videoRef = useRef(null);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.autoplay = true;
            videoRef.current.muted = true;
            videoRef.current.loop = false;
            videoRef.current.controls = false;
        }
    }, []);

    const [isMobileView, setIsMobileView] = useState(false);
    const [fadeIn, setFadeIn] = useState(false);
    const updateView = () => {
        setIsMobileView(window.innerWidth <= 991);
    };
    const [openGrandOpening, setOpenGrandOpening] = useState(false);
    useEffect(() => {
        const timer = setTimeout(() => {
            setOpenGrandOpening(true);
        }, 5000);
        return () => clearTimeout(timer);
    }, []);
    useEffect(() => {
        if (openGrandOpening) {
            setFadeIn(true);
        }
    }, [openGrandOpening]);
    useEffect(() => {
        const videoElement = videoRef.current;
        const handleVideoEnd = () => {
            videoElement.classList.add('video-fade-in');
            videoElement.play();
            setTimeout(() => {
                // videoElement.currentTime = 0;
                videoElement.classList.remove('video-fade-in');
            }, 3000);
        };
        if (videoElement) {
            videoElement.addEventListener('ended', handleVideoEnd);
        }
        return () => {
            if (videoElement) {
                videoElement.addEventListener('ended', handleVideoEnd);
            }
        };
    }, []);
    const [isMobile, setIsMobile] = useState(false);
    const handleResize = () => {
        setIsMobile(window.innerWidth < 768);
    };
    useEffect(() => {
        handleResize();
        updateView();
        window.addEventListener('resize', handleResize, updateView);
        return () => {
            window.removeEventListener('resize', handleResize, updateView);
        };
    }, []);
    return (
        <>
            <div className="banner-wrap home-banner-wrap pt-0">
                <div className='video-relative'>
                    {/* {isPageLoaded ? ( */}
                    {!isMobile &&
                        <video className='video-background' width="100%" ref={videoRef} muted loop playsInline autoPlay preload="auto">
                            <source src={`${getImages('banner_video.mp4')}`} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    }
                    {isMobile &&
                        <video className='video-background m-video' width="100%" ref={videoRef} muted loop playsInline autoPlay preload="auto">
                            <source src={`${getImages('banner_video.mp4')}`} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    }
                    {/* ): 
                                <img src={getImages('banner_video_img.webp')} alt='banner video'/>
                            } */}
                </div>
                <div className='home-overlay-pos'>
                    <div className='home-banner-pos'>
                        <div className='container'>
                            <div className='d-flex align-items-center banner-flex'>
                                <div>
                                    <h1 className='banner-sm-title text-uppercase mb-1'>World’s Largest McLaren Retailer</h1>
                                    <h2 className='lg-title text-uppercase'>McLaren Orlando</h2>
                                    <div className='mt-28'>
                                        <Link to="/inventory" className='theme-btn text-uppercase'>View Inventory</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeVideo